import { Injectable } from '@angular/core';
import { PermissionModel } from '../models/permission.model';
import { ApiInterface, ApiService } from '../../api/api.service';

@Injectable()
export class PermissionService extends ApiService implements ApiInterface {

    public entityName = 'permission';

    public restEndpoint = 'permissions';

    public model = PermissionModel;

    protected cache = false;

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/authentication/services/permission.service.ts